import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { debounceTime, map, startWith, switchMap, tap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  Validators
} from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { CarWorkshopDTO } from "../../models/car-workshop-dto";
import { CarWorkshopService } from "@core/services/car-workshop.service";
import { SearchFormDTO } from "src/app/modules/private/modules/car-workshop/components/models/search-form-dto";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { CarWorkshopSimplifiedDTO } from "@shared/models/car-workshop-simplified-dto";
import { DEFAULT_PAGINATION } from "@shared/constants/default-pagination";
import { PageManager } from "@shared/models/page-manager";

@Component({
  selector: "app-smartfleet-car-workshop-auto-complete",
  templateUrl: "./car-workshop-auto-complete.component.html",
  styleUrls: ["./car-workshop-auto-complete.component.scss"],
  standalone: false
})
export class CarWorkshopAutoCompleteComponent implements OnInit {
  loading = false;
  isRequired = true;
  carWorkshop = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.carWorkshop,
    clientId: ""
  });

  carWorkshops$: Observable<CarWorkshopSimplifiedDTO[]>;

  @Input() title = "";
  @Input() requiredText = "";
  @Input() page = "";
  @Input() hideRequiredMarker = true;
  @Input() clientId: number;
  @Input() set required(value: boolean) {
    if (value && !this.disabled) {
      this.isRequired = true;
      this.searchForm.controls.name.setValidators([Validators.required]);
      this.searchForm.updateValueAndValidity();
    } else {
      this.isRequired = false;
      this.searchForm.controls.name.clearValidators();
      this.searchForm.updateValueAndValidity();
    }
  }
  @Input() set disabled(value: boolean) {
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  @Output() onChange: any = new EventEmitter<CarWorkshopSimplifiedDTO>();
  @Input() isNegotiation = false;
  @Input() negotiationId: number;

  constructor(
    private carWorkshopService: CarWorkshopService,
    private fb: UntypedFormBuilder,
    private loadingDrivebService: LoadingDrivebService
  ) {}

  ngOnInit() {
    this.searchForm.controls.clientId.setValue(this.clientId);
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "service-request-pending":
          key = "srp-carWorkshop";
          break;
        case "service-request-vehicle":
          key = "srv-carWorkshop";
          break;
        case "service-request":
          key = "srq-carWorkshop";
          break;
        case "scheduling-request":
          key = "sr-carWorkshop";
          break;
        case "debit-notes":
          key = "dn-carWorkshop";
          break;
        case "debit-notes-issued":
          key = "dn-carWorkshop-issued";
          break;
        case "invoices-validation-list":
          key = "ivl-carWorkshop";
          break;
        case "invoices-parts":
          key = "inv-parts-carWorkshop";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const carWorkshop = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(carWorkshop["tradingName"]);
      }
    } else {
      this.clean();
    }

    this.carWorkshops$ = this.carWorkshop.valueChanges.pipe(
      startWith(""),
      debounceTime(200),
      tap(
        () => (
          (this.loading = true), this.loadingDrivebService.setAutoMode(false)
        )
      ),
      switchMap((value: string) => {
        if (value) {
          const searchForm = {} as SearchFormDTO;
          searchForm.filter = value.toUpperCase();
          searchForm.clientId = this.clientId;

          if (this.isNegotiation && this.negotiationId) {
            return this.carWorkshopService.findByFiltersAutoCompleteNegotiation(
              searchForm,
              this.negotiationId
            );
          }

          return this.carWorkshopService.findByFiltersAutoComplete(searchForm);
        } else {
          this.onChange.emit({} as CarWorkshopSimplifiedDTO);
          return of([]) as Observable<CarWorkshopSimplifiedDTO[]>;
        }
      }),
      map((result) => {
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
        return result;
      })
    );
  }

  handleCarWorkshopChange(
    event: MatOptionSelectionChange,
    carWorkshop: CarWorkshopSimplifiedDTO
  ) {
    if (event.isUserInput === true) {
      this.onChange.emit(carWorkshop);
    }
  }

  clean(): void {
    this.searchForm.reset();
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
  }

  setNameFromLocalStorage(localStorageKey: string): void {
    if (
      localStorage.getItem(localStorageKey) != null &&
      localStorage.getItem(localStorageKey) != ""
    ) {
      const carWorkshop = JSON.parse(localStorage.getItem(localStorageKey));
      this.searchForm.controls.name.setValue(carWorkshop["tradingName"]);
    }
  }
}
